import { store } from "redux/store";
import HTTPRequest, {
  FHIRSave,
  FHIRSearch,
  HTTPMetadata,
  HTTPRequestUnauthenticated,
  NokiService,
} from "./http";
import { toast } from "react-toastify";
import i18n from "multilingual";
import { GET, POST } from "config/constants/adapter_constants";
import { getTenantFromToken } from "config/helpers/common_helper";

const data = store.getState();

export const GET_PERSON_FROM_UID = async (uid) => {
  try {
    let res = await FHIRSearch(`Person`, `identifier=${uid}`);
    if (res?.data?.total > 0) {
      return res.data.entry[0];
    } else {
      toast.info(i18n.t("common.PERSON_DATA_NOT_FOUND"));
    }
  } catch (err) {
    toast.error(i18n.t("common.ERROR"));
  }
};

export const GET_TENANTS = async (email) => {
  try {
    let response = await HTTPRequestUnauthenticated.get(
      `auth/user/tenants?email=${encodeURIComponent(email)}`
    );
    return response?.data;
  } catch (err) {
    console.log(err);
  }
};

export const GET_PRACTITIONER_FROM_UID = async (uid) => {
  try {
    let res = await FHIRSearch(`Practitioner`, `identifier=${uid}`);
    if (res?.data?.total > 0) {
      return res.data.entry[0];
    } else {
      // toast.info(i18n.t('common.PRACTITIONER_DATA_NOT_FOUND'))
    }
  } catch (err) {
    toast.error(i18n.t("common.ERROR"));
  }
};

export const GET_ORGANISATION_FROM_TENENT_ID = async (tenentID) => {
  try {
    let res = await FHIRSearch(`Organization`, `identifier=${tenentID}`);
    if (res?.data?.total > 0) {
      return res.data.entry[0];
    } else {
      // toast.info(i18n.t('common.PRACTITIONER_DATA_NOT_FOUND'))
    }
  } catch (err) {
    toast.error(i18n.t("common.ERROR"));
  }
};

export const INITIATE_SIGN_UP = async (payload) => {
  return await NokiService(POST, "/initiate-sign-up", payload);
};

export const VERIFY = async (verificationCode) => {
  try {
    let res = await NokiService(GET, `/verify-sign-up/${verificationCode}`);
    return res;
  } catch (e) {
    console.error(e);
  }
};

export const VERIFY_RESET_PASSWORD = async (payload) => {
  try {
    let res = await NokiService(POST, `/password-reset/verify/${payload}`);
    return res;
  } catch (e) {
    console.error(e);
  }
};

export const CONFIRM_RESET_PASSWORD = async (payload, password) => {
  try {
    let res = await HTTPRequestUnauthenticated.post(
      `auth/password-reset/confirm/${payload}`,
      password
    );
    return res;
  } catch (e) {
    console.error(e);
  }
};

export const SET_PASSWORD = async ({ verificationCode, payload }) => {
  try {
    let res = await NokiService(
      POST,
      `/complete-sign-up/${verificationCode}`,
      payload
    );
    return res;
  } catch (e) {
    console.error(e);
  }
};

export const REQUEST_PASSWORD_RESET = async (tenentID, payload) => {
  try {
    let res = await NokiService(
      POST,
      `/password-reset/${tenentID}/request`,
      payload
    );
    return res;
  } catch (e) {
    console.error(e);
  }
};

export const LOGOUT_FROM_SERVER = async () => {
  try {
    let res = await HTTPRequest.post(
      `/auth/tenants/${getTenantFromToken()}/logout`
    );
    return res;
  } catch (e) {
    console.error(e);
  }
};

export const SPAWN_ZOOM_BOT = async (payload) => {
  try {
    const {
      meetingNumber,
      meetingPassword,
      url,
      patientId,
      practitionerId,
      organizationId,
    } = payload;
    //action, module, params = ``, payload = {}, url=""
    const response = await HTTPMetadata(
      "post",
      "",
      "",
      {
        meetingNumber,
        meetingPassword,
        url,
        patientId,
        practitionerId,
        organizationId,
      },
      "ai/zoom/spawnBot"
    );

    return response;
  } catch (err) {
    toast.error(
      "Failed to join Zoom call. Please check your details and try again."
    );
    throw err;
  }
};

export const UPDATE_USER = async (payload) => {
  try {
    let response = await NokiService(
      POST,
      `/${getTenantFromToken()}/user/${payload?.userId}/update`,
      payload
    );
    return response;
  } catch (err) {
    toast.error(
      i18n.t(`error_messages.${err?.response?.data?.code}`) ||
        i18n.t("common.ERROR")
    );
  }
};
export const GET_USER = async (payload) => {
  const token = localStorage.getItem(`jwtToken`);
  const headers = {
    Authorization: `Bearer ${token}`,
    "x-enliv-tenant-id": getTenantFromToken(),
  };
  try {
    let response = await HTTPRequestUnauthenticated.get(
      `auth2/auth/getUser?uid=${payload}`,

      { headers }
    );
    return response;
  } catch (err) {
    console.error("error: ", err);
  }
};

export const ASSIGN_FORM = async (payload) => {
  try {
    let res = await NokiService(
      POST,
      `/intake-form/schedule/${getTenantFromToken()}`,
      payload
    );
    return res;
  } catch (e) {
    console.error(e);
    toast.error(e?.response?.data?.message);
  }
};
